import { createAction, handleActions } from 'redux-actions';

const initialState = {
	loading: false,
};

// ------------------------------------
// Constants
// ------------------------------------
export const TOGGLE_LOADING_ANIMATION = 'TOGGLE_LOADING_ANIMATION';

// ------------------------------------
// Actions
// ------------------------------------

const toggleLoadingAnimation = createAction(TOGGLE_LOADING_ANIMATION, loading => loading);

export const actions = {
	toggleLoadingAnimation,
};

// ------------------------------------
// Reducer
// ------------------------------------
export default handleActions({
	[TOGGLE_LOADING_ANIMATION]: (state, { payload }) => {
		return Object.assign({}, state, { loading: payload });
	},
}, initialState);



// WEBPACK FOOTER //
// ./src/redux/modules/view.js